export const PAYMENT_METHODS = {
    WALLET: 'WALLET',
    PAYMENT_GATEWAY: 'PAYMENT_GATEWAY',
};
